<div class="col-lg-12 text-center loading" *ngIf="loading">{{'system.loading' | translate}}</div>
<div class="col-lg-12 text-center not-found" *ngIf="list && !loading && list?.length === 0">
  {{'system.no.results.found' | translate}}
</div>
